<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [dismissableMask]="false"
  appendTo="body"
  [draggable]="false"
  [closeOnEscape]="true"
  [closable]="true"
  (onHide)="closeModal()"
  [style]="{ width: '25rem', height: 'auto' }">
  <ng-template #header>
    <div class="modal-header">
      <span class="header-title">{{ 'doktar_app.account.confirm_otp.title' | translate }}</span>
    </div>
  </ng-template>
  <div class="modal-subtitle">
    <span>{{ 'doktar_app.account.confirm_otp.description' | translate }}</span>
  </div>
  <div class="otp-confirmation">
    <span class="otp-label">
      {{ 'doktar_app.account.confirm_otp.input.label' | translate }}
    </span>
    <input type="number" min="0" max="999999" [incremental]="false" [(ngModel)]="otpValue" class="otp-input" />
  </div>
  <ng-template #footer>
    <div class="otp-buttons">
      <button
        pButton
        [label]="'doktar_app.common.confirm_button' | translate"
        class="confirm-otp-button"
        [disabled]="!otpValue || otpValue.toString().length !== 6"
        (click)="confirmOtp()"></button>
      <button
        pButton
        [label]="'doktar_app.common.cancel_button' | translate"
        class="cancel-otp-button"
        severity="secondary"
        (click)="closeModal()"></button>
    </div>
  </ng-template>
</p-dialog>
